import { customTextBlock, heading,
  paragraph,
  button } from "../../../text/nodes"
import { SmallCTA as SmallCTAEditor } from "./small-cta"
import { ImageLeftCTARightSettings as SmallCTASettings } from "./small-cta-settings"
import SmallCTAPreview from "./small-cta-preview.png"
import { getFont } from "app/regions/blocks/shared/fonts"

export const SmallCTA = {
  name: "SmallCTA",
  label: "image on left, call to action on right",
  EditorComponent: SmallCTAEditor,
  SettingsComponent: SmallCTASettings,
  image: SmallCTAPreview,
  defaultProperties: {
    backgroundColor: "#F5F5F5",
    headingColor: "#1A1A1A",
    headingFontFamily: getFont("System Font"),
    headingFontWeight: 700,
    textColor: "#3C3C3C",
    textFontFamily: getFont("System Font"),
    textFontWeight: 400,
    horizontalPadding: 32,
    verticalPadding: 32,
    marginTop: 24,
    marginBottom: 24,
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
    columnRatio: 70,
    borderColor: "#000000",
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderLeftWidth: 0,
    borderBottomWidth: 0
  },
  defaultChildren: [
    customTextBlock([
      heading("two", "Title"),
      paragraph("Lorem ipsum dolor sit amet, consectetur adipiscing elit.")
    ]),
    customTextBlock([
      button("Button", {
        size: "medium",
        roundedCornerOption: "full",
        align: "right"
      })
    ])
  ]
}
